/**
 * Application configuration — env-driven, typed.
 *
 * During migration we re-export from the legacy `@config/config` so that
 * services keep working. New code should use `config.*` from this module.
 *
 * NOTE: Bun reads `.env` automatically and exposes variables via
 * `process.env`. Client-side variables should use the `BUN_PUBLIC_*`
 * prefix. Legacy `VITE_*` vars are kept as fallbacks while we migrate
 * env files.
 */

// Legacy config — kept as compatibility layer during migration.
import {ConfEnv as legacy} from "@config/config";

const env = (key: string, fallback: string): string => {
  const bunPublic = process.env[`BUN_PUBLIC_${key}`];
  const vite = process.env[`VITE_${key}`];
  return bunPublic ?? vite ?? fallback;
};

const apiBaseUrl = env("BASE_URL", "https://api-dev.raspaygana.com.ve/api");
const walletApiUrl = env("WALLET_URL", "https://wallet-dev.raspaygana.com.ve/api");
const onboardingApiUrl = env("ONBOARDING_URL", apiBaseUrl);

export const config = {
  /** Root API URL without the `/v1` segment (e.g. auth endpoints live here). */
  apiRootUrl: apiBaseUrl,
  /** API base pinned to `/v1` — the default for most domain endpoints. */
  apiBaseUrl: `${apiBaseUrl}/v1`,
  walletApiUrl: `${walletApiUrl}/v1`,
  onboardingApiUrl: `${onboardingApiUrl}/v1`,
  isProd: process.env.NODE_ENV === "production",
  isDev: process.env.NODE_ENV !== "production",
  sessionKey: "coronando_session",
  defaultCurrency: "VES",
  /** Legacy flat config surface — keep for services not yet migrated. */
  legacy,
} as const;

export type Config = typeof config;
